const diactriticsUnicodeRangeRegex = /[\u0300-\u036f]/g;

const specialCharacters: { [key: string]: string } = {
  ß: 'ss',
  æ: 'ae',
  œ: 'oe',
  ł: 'l',
};

/**
 * Normalizes a string to be searchable by replacing special characters,
 * removing diacritics, and converting to lowercase.
 *
 * Usage note:
 * - normalization must be done on both the search input and the target strings
 */
export const normalizeString = (string: string): string =>
  string
    .replaceAll(/[ßæœł]/g, (match) => specialCharacters[match])
    .normalize('NFD')
    .replaceAll(diactriticsUnicodeRangeRegex, '')
    .toLowerCase();
